import { useState } from 'react'

import { Suggestion } from '../types'

export const useAISelectSuggestion = () => {
  const [selectedSuggestion, setSelectedSuggestion] = useState<Suggestion | undefined>(undefined)

  return {
    selectedSuggestion,
    setSelectedSuggestion,
  }
}
